import React, { Component } from 'react';
import { Col } from "antd";
import "./index.scss";


class index extends Component {
    render() {
        return (
            <div className="theChart">
                F&B Dept Profit %  餐饮部门利润率
                <div id="food" style={{ height: 400, width: '100%' }}></div>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/analysisChart/food.js